/* Product page: variants, gallery with zoom and viewer, add to bag, size guide, complete the look, recommendations. */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var RM = window.RM || {};
  var S = RM.str || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = $('[data-product]');
  if (!root) return;
  var data = JSON.parse($('[data-product-json]', root).textContent);
  var form = $('#pf-main');
  var idInput = $('[data-variant-id]', root);
  var addBtn = $('[data-add]', root);
  var sizePos = +root.dataset.sizePos || 0;

  /* ---------- gallery ---------- */
  var slides = $$('[data-slide]', root), thumbs = $$('[data-thumb]', root), gmain = $('[data-gmain]', root), count = $('[data-gcount]', root);
  var cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); s.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
    var th = thumbs[cur]; if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
  if (gmain) {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    gmain.addEventListener('mousemove', function (e) {
      if (!fine) return;
      var r = gmain.getBoundingClientRect();
      gmain.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
      gmain.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      gmain.classList.add('zoom');
    });
    gmain.addEventListener('mouseleave', function () { gmain.classList.remove('zoom'); });
    gmain.addEventListener('click', openViewer);
    gmain.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openViewer(); }
      if (e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowLeft') show(cur - 1);
    });
    var sx = null;
    gmain.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    gmain.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      var rtl = document.documentElement.dir === 'rtl';
      if (Math.abs(dx) > 40) { show(cur + ((dx < 0) !== rtl ? 1 : -1)); e.preventDefault(); }
    });
  }

  /* viewer */
  var viewer = $('[data-viewer]'), vImg = $('[data-viewer-img]'), vPos = $('[data-viewer-pos]'), vThumbs = $('[data-viewer-thumbs]');
  var vi = 0;
  function vShow(i) {
    if (!slides.length) return;
    vi = (i + slides.length) % slides.length;
    var s = slides[vi];
    vImg.src = s.dataset.full || ''; vImg.alt = s.dataset.alt || '';
    if (vPos) vPos.textContent = (vi + 1) + ' ' + (S.of || '/') + ' ' + slides.length;
    $$('button', vThumbs).forEach(function (b, k) { b.setAttribute('aria-current', k === vi ? 'true' : 'false'); });
  }
  function openViewer() {
    if (!viewer || !slides.length || !slides[cur].dataset.full) return;
    if (!vThumbs.children.length) {
      vThumbs.innerHTML = slides.map(function (s, k) { return '<button type="button" data-k="' + k + '"><img src="' + s.dataset.full.replace(/width=\d+/, 'width=160') + '" alt=""></button>'; }).join('');
      $$('button', vThumbs).forEach(function (b) { b.addEventListener('click', function () { vShow(+b.dataset.k); }); });
    }
    vShow(cur);
    RM.openLayer(viewer, '[data-viewer-close]');
  }
  if (viewer) {
    $('[data-viewer-close]', viewer).addEventListener('click', function () { RM.closeLayer(viewer); show(vi); });
    $('[data-viewer-prev]', viewer).addEventListener('click', function () { vShow(vi - 1); });
    $('[data-viewer-next]', viewer).addEventListener('click', function () { vShow(vi + 1); });
    viewer.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') vShow(vi + 1); if (e.key === 'ArrowLeft') vShow(vi - 1); });
  }

  /* ---------- variants ---------- */
  function selected() {
    return data.options.map(function (o, i) {
      var c = form && form.querySelector('input[name="option' + (i + 1) + '"]:checked');
      return c ? c.value : null;
    });
  }
  function findVariant(sel) {
    return data.variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); });
  }
  function setAddLabel(txt, disabled) {
    if (!addBtn) return;
    $$('[data-add-label]', addBtn).forEach(function (s) { s.textContent = txt; });
    addBtn.disabled = !!disabled;
  }
  function updateAvailability(sel) {
    data.options.forEach(function (o, i) {
      $$('input[name="option' + (i + 1) + '"]', form).forEach(function (inp) {
        var ok = data.variants.some(function (v) {
          if (!v.available || v.options[i] !== inp.value) return false;
          return v.options.every(function (x, k) { return k === i || sel[k] === null || sel[k] === x; });
        });
        inp.parentElement.classList.toggle('na', !ok);
      });
    });
  }
  function onChange() {
    var sel = selected();
    data.options.forEach(function (o, i) {
      var lbl = form.querySelector('[data-option="' + (i + 1) + '"] [data-opt-label]');
      if (lbl) lbl.textContent = sel[i] || '';
    });
    var err = $('[data-size-err]', root); if (err) err.hidden = true;
    var sz = $('[data-sizes]', root); if (sz) sz.classList.remove('bad');
    updateAvailability(sel);
    var v = sel.indexOf(null) === -1 ? findVariant(sel) : null;
    idInput.value = v ? v.id : '';
    if (v) {
      var pr = $('[data-price]', root); if (pr) pr.innerHTML = v.priceText;
      if (v.price === 0) setAddLabel(S.priceSoon, true);
      else if (!v.available) setAddLabel(S.soldOut, true);
      else setAddLabel(S.add, false);
      var low = $('[data-low]', root); if (low) low.hidden = !v.low;
      if (v.media) {
        var k = slides.findIndex(function (s) { return +s.dataset.mediaId === v.media; });
        if (k > -1) show(k);
      }
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u.toString());
    } else {
      setAddLabel(S.add, false);
    }
  }
  if (form) {
    form.addEventListener('change', function (e) { if (e.target.name && /^option\d/.test(e.target.name)) onChange(); });
    updateAvailability(selected());
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput.value) {
        var err = $('[data-size-err]', root); if (err) err.hidden = false;
        var sz = $('[data-sizes]', root); if (sz) { sz.classList.add('bad'); var f = sz.querySelector('input'); if (f) f.focus(); }
        return;
      }
      addBtn.setAttribute('aria-busy', 'true');
      setAddLabel(S.adding, false);
      RM.addToCart([{ id: +idInput.value, quantity: 1 }], { title: data.title, open: true, toast: false })
        .then(function () { setAddLabel(S.addedAgain, false); })
        .catch(function () { setAddLabel(S.add, false); })
        .finally(function () { addBtn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- size guide ---------- */
  var guide = $('[data-guide]');
  if (guide) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-guide-open]')) {
        var sel = selected(); var s = sizePos ? sel[sizePos - 1] : null;
        $$('[data-size-row]', guide).forEach(function (tr) { tr.classList.toggle('on', !!s && tr.dataset.sizeRow === s); });
        RM.openLayer(guide, '[data-guide-close]:not(.scrim)');
      }
      if (e.target.closest('[data-guide-close]')) RM.closeLayer(guide);
    });
    $$('[data-unit]', guide).forEach(function (b) {
      b.addEventListener('click', function () {
        var inch = b.dataset.unit === 'in';
        $$('[data-unit]', guide).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-cm]', guide).forEach(function (td) {
          var cm = parseFloat(td.dataset.cm);
          td.textContent = isNaN(cm) ? td.dataset.cm : (inch ? (Math.round(cm / 2.54 * 10) / 10) : td.dataset.cm);
        });
      });
    });
  }

  /* ---------- complete the look ---------- */
  var look = $('[data-look]');
  if (look) {
    look.addEventListener('click', function (e) {
      var b = e.target.closest('[data-look-variant]');
      if (b) {
        $$('[data-look-variant]', b.parentElement).forEach(function (x) { var on = x === b; x.setAttribute('aria-pressed', on ? 'true' : 'false'); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var er0 = $('[data-look-err]', look); if (er0) er0.hidden = true;
        return;
      }
      var add = e.target.closest('[data-add-look]');
      if (!add) return;
      var items = [], missing = false;
      $$('[data-look-item]', look).forEach(function (it) {
        var on = $('[data-look-variant][aria-pressed="true"]', it);
        if (!on) missing = true; else items.push({ id: +on.dataset.lookVariant, quantity: 1 });
      });
      var mainNeedsSize = !idInput.value;
      if (missing || mainNeedsSize) {
        var er = $('[data-look-err]', look); if (er) er.hidden = false;
        if (mainNeedsSize) { var err = $('[data-size-err]', root); if (err) err.hidden = false; }
        return;
      }
      items.unshift({ id: +idInput.value, quantity: 1 });
      add.setAttribute('aria-busy', 'true');
      RM.addToCart(items, { open: true, toast: false }).finally(function () { add.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- you may also like (Section Rendering API) ---------- */
  $$('[data-recos]').forEach(function (sec) {
    if (sec.querySelector('[data-rail]')) { RM.initRail && RM.initRail(sec); return; }
    fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var inner = d.querySelector('[data-recos]');
      if (inner && inner.querySelector('[data-rail]')) {
        sec.innerHTML = inner.innerHTML;
        RM.initRail && RM.initRail(sec);
        RM.syncFavs && RM.syncFavs();
      }
    }).catch(function () {});
  });
});
